module.exports = __webpack_public_path__ + "img/hometitle.7f8f5b6f.png";